var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "inherit"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M21 58V33h-6V23h6v-4A16 16 0 0 1 37 3v10a6 6 0 0 0-6 6v4h5v10h-5v25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    stroke: "none",
    d: "M-4-13H4V-4H13V4H4V13H-4V4H-13V-4H-4Z",
    transform: "translate(49 45) rotate(45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFx);
export default __webpack_public_path__ + "static/media/fx.fc4f4eb5ad8b5eefc06c3b50408c9253.svg";
export { ForwardRef as ReactComponent };